import 'angular';
import template from './visualizations_button.template.html?raw';

angular
  .module('fundingSearchApp.directives.visualizationsButton', [])
  .run(['$templateCache', $templateCache => {
    $templateCache.put(template, template);
  }])
  .directive('visualizationsButton', () => {
    const link = $scope => {
      $scope.getTooltipMessagge = () => {
        return $scope.showVisualizations ? 'Return to results list' : 'Visualize search results';
      };
    };

    return {
      restrict: 'E',
      templateUrl: template,
      scope: {
        showVisualizations: '=',
        toggleVisualizations: '='
      },
      link
    };
  });
